import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDlaKDVJi_zfumDiWCFPdODmpG_iLxJfEk",
  authDomain: "spendle-cc21f.firebaseapp.com",
  projectId: "spendle-cc21f",
  storageBucket: "spendle-cc21f.firebasestorage.app",
  messagingSenderId: "1047343946192",
  appId: "1:1047343946192:web:397746461b7f0899b381d5",
  measurementId: "G-NLJHXTC59G",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
